import styles from "./TransparentButton.module.scss";

interface TransparentButtonProps {
  text: string;
  setValue: (value: string) => void;
  selectedValue: string;
  /**
   * Identity of this option, when the label is not unique — two sizes can both
   * be called "Large". Defaults to `text`, so existing call sites are unchanged.
   */
  value?: string;
}

function TransparentButton(props: TransparentButtonProps) {
  const { text, setValue, selectedValue, value } = props;
  const optionValue = value ?? text;

  const handleOnClick = () => {
    setValue(optionValue);
  };
  return (
    <div
      className={`body-bold-medium ${styles.transparentButtonWrapper} ${
        selectedValue === optionValue ? styles.transparentButtonActive : ""
      }`}
      onClick={handleOnClick}
    >
      {text}
    </div>
  );
}

export default TransparentButton;
